import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const CLAVE = 'cyl1884:pista-vista';

/** La franja que explica el mecanismo del recurso donde se usa, no en la portada.
 *
 *  Observando a un usuario nuevo se vio que no descubría la sincronización: la promesa estaba en la
 *  portada y aquí solo había una frase en cursiva gris dentro del panel de la ficha, con aspecto de
 *  pie de foto. Esto lo dice en la primera línea del contenido, con el mismo realce que llevan las
 *  menciones para que la asociación sea visual, y se puede cerrar para siempre.
 */
export function Pista() {
  const { pathname } = useLocation();
  // se lee antes del primer pintado: si se leyera en un efecto, la franja aparecería después y
  // empujaría hacia abajo el mapa y el texto justo cuando el lector va a pulsar algo
  const [oculta, setOculta] = useState(() => {
    try { return window.localStorage.getItem(CLAVE) === '1'; } catch { return false; }
  });

  const procede = pathname.startsWith('/leer') || pathname.startsWith('/explorar');
  if (!procede || oculta) return null;

  const cerrar = () => {
    setOculta(true);
    try { window.localStorage.setItem(CLAVE, '1'); } catch { /* sin almacenamiento */ }
  };

  return (
    <aside className="pista" aria-label="Cómo se usa">
      <b className="pista__eti">Cómo se usa</b>
      <p>
        Los nombres <span className="pista__muestra">resaltados</span> del texto son lugares: púlsalos y se
        señalan en el mapa. Pulsa un punto del mapa y te lleva al pasaje donde Quadrado lo describe.
      </p>
      <button type="button" className="pista__cerrar" onClick={cerrar}>Entendido ✕</button>
    </aside>
  );
}
